exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gneyai-rive[data-v-38e1604e]{display:flex;align-items:center;justify-content:center}.global-gney-ai[data-v-38e1604e]{cursor:pointer}", ""]);

// exports
